import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography, makeStyles } from "@material-ui/core";
import AddressCard from "../AddressCard";
import capchain from "./images/capchain.png";
import { useHistory } from "react-router-dom";


const useStyles = makeStyles(() => ({
  header: {
    background: "#fff",
    paddingRight: "20px",
    paddingLeft: "20px",
    "@media (max-width: 900px)": {
      paddingLeft: 0,
    },
  },
  logo: {
    fontFamily: "Work Sans, sans-serif",
    fontWeight: 600,
    color: "#F0B90B",
    textAlign: "left",
    cursor: "pointer"
  },
  menuButton: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: 700,
    size: "18px",
    marginLeft: "38px",
    color: "#F0B90B",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  drawerContainer: {
    padding: "20px 30px",
  },
  mobileMenu: {
    color: "#F0B90B",
  },
  logoImage: {
    height: "50px",
    width: "50px",
    cursor: "pointer"
  },
}));

const AppHeader = ({ ethAccount }) => {
  const { header, logo, toolbar, logoImage } = useStyles();
  const history = useHistory();
  const [state, setState] = useState({
    mobileView: false,
  });

  const { mobileView } = state;

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 900
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  function handleClick() {
    history.push("/");
  }

  const capChainLogo = (mobile = false) => {
    if (mobile) {
      return <img onClick={handleClick} src={capchain} className={logoImage} alt="Logo" />;
    } else {
      return (
        <Typography onClick={handleClick} variant="h6" component="h1" className={logo}>
          Capchain
        </Typography>
      );
    }
  };

  const displayMobile = () => {
    return (
      <Toolbar className={toolbar}>
        <div> {capChainLogo(true)} </div>
        <AddressCard account={ethAccount} />
      </Toolbar>
    );
  };
  const displayDesktop = () => {
    return (
      <Toolbar className={toolbar}>
        {capChainLogo()}
        <AddressCard account={ethAccount} />
      </Toolbar>
    );
  };



  

  return (
    <header>
      <AppBar elevation={2} className={header}>
        {mobileView ? displayMobile() : displayDesktop()}
      </AppBar>
    </header>
  );
};

export default AppHeader;
